import React, { useEffect, useState } from 'react';
import { CheckCircle2, X, Mail } from 'lucide-react';
import { Loan } from '../data';
interface ClearSOSModalProps {
  loan: Loan;
  onClose: () => void;
  onConfirm: (clearanceNote: string) => void;
}
export function ClearSOSModal({
  loan,
  onClose,
  onConfirm
}: ClearSOSModalProps) {
  const [note, setNote] = useState('');
  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [onClose]);
  const canSubmit = note.trim().length > 0;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-22">
      <div className="bg-white dark:bg-slate-900 rounded-xl shadow-2xl w-full max-w-lg flex flex-col overflow-hidden border border-slate-200 dark:border-slate-700 animate-in fade-in zoom-in-95 duration-200" data-id="element-23">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 dark:border-slate-800 bg-emerald-50 dark:bg-emerald-900/20" data-id="element-24">
          <div className="flex items-center space-x-3" data-id="element-25">
            <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center" data-id="element-26">
              <CheckCircle2 className="w-4 h-4 text-white" data-id="element-27" />
            </div>
            <div data-id="element-28">
              <h2 className="text-base font-semibold text-slate-900 dark:text-white" data-id="element-29">
                Clear SOS — {loan.loanName}
              </h2>
              <p className="text-xs text-slate-500 dark:text-slate-400" data-id="element-30">
                A clearance note is required for audit history
              </p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 rounded-full hover:bg-white/60 dark:hover:bg-slate-800 transition-colors" data-id="element-31">
            <X className="w-5 h-5" data-id="element-32" />
          </button>
        </div>

        <div className="p-6 space-y-4" data-id="element-33">
          {loan.sosNote && <div className="bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-md p-3 text-sm" data-id="element-34">
              <div className="text-[11px] uppercase tracking-wider font-semibold text-slate-500 dark:text-slate-400 mb-1" data-id="element-35">
                Active SOS Note
              </div>
              <div className="text-slate-700 dark:text-slate-200" data-id="element-36">
                {loan.sosNote.text}
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400 mt-1" data-id="element-37">
                — {loan.sosNote.author},{' '}
                {new Date(loan.sosNote.timestamp).toLocaleString()}
              </div>
            </div>}

          <div data-id="element-38">
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5" data-id="element-39">
              Clearance Note <span className="text-sos-500" data-id="element-40">*</span>
            </label>
            <textarea autoFocus rows={4} value={note} onChange={e => setNote(e.target.value)} placeholder="Document how the SOS issue was resolved…" className="w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none dark:text-white resize-none" data-id="element-41" />
          </div>

          <div className="flex items-start gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 rounded-md text-xs text-slate-600 dark:text-slate-400" data-id="element-42">
            <Mail className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-slate-400" data-id="element-43" />
            <span data-id="element-44">
              A clearance email will be automatically sent to the original SOS
              recipients and all admin always-included CCs.
            </span>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50 flex justify-end space-x-2" data-id="element-45">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-md transition-colors" data-id="element-46">
            Cancel
          </button>
          <button onClick={() => onConfirm(note.trim())} disabled={!canSubmit} className="px-4 py-2 text-sm font-medium bg-emerald-600 hover:bg-emerald-500 text-white rounded-md transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center" data-id="element-47">
            <CheckCircle2 className="w-4 h-4 mr-1.5" data-id="element-48" />
            Clear SOS
          </button>
        </div>
      </div>
    </div>;
}